export default "__VITE_ASSET__HMQXqKxU__"